import * as React from 'react'
import { NormalizedCache } from 'apollo-cache-inmemory'
import { connect, Dispatch } from 'react-redux'

import { ApolloClient, ApolloQueryResult } from 'apollo-client'
import { DEFAULT_VALUES_QUERY, DefaultValues } from '../defaultValuesQuery'
import { Form as StyledForm } from '../../../Styled/Shared'
import { SpaceType } from '../../../SpaceTypeSelect/spaceTypeQueries'
import { Store } from '../../../../reducers'
import { getActiveSpaceType } from '../../../../reducers/project'
import { loadDefaultValues } from '../../../../actions/project'
import { Action } from '../../../../actions/types'
import { recordEvent } from '../../../../analytics'

import CustomSelect from '../../../Shared/CustomSelect'
import { getLocation } from 'src/location_changes/conversionHelper'

type ExternalProps = {
  currentSpaceType: string
  spaceTypes: SpaceType[]
  loadDefaults: (spaceType: string, defaults: DefaultValues) => Action
}

type Props = ExternalProps

type Response = ApolloQueryResult<{ defaultValues: DefaultValues }>

class SpaceForm extends React.Component<Props> {
  static contextTypes = {
    client: () => null
  }
  client: ApolloClient<NormalizedCache>

  // tslint:disable-next-line
  constructor(props: Props, context?: any) {
    super(props)
    this.client = context.client
    this.getDefaults = this.getDefaults.bind(this)
  }

  parseOptions() {
    return this.props.spaceTypes.map(bt => (
      <option value={bt.id} key={bt.id}>
        {bt.displayName}
      </option>
    ))
  }

  getDefaults(e: React.SyntheticEvent<HTMLSelectElement>) {
    if (
      !window.confirm('Change space type? All values will be reset to defaults')
    ) {
      return
    }
    const spaceId = e.currentTarget.value

    // This is an exact copy of the code in Workspace and should probably be deduped.
    this.client
      .query({
        query: DEFAULT_VALUES_QUERY,
        variables: { spaceId: spaceId, location: getLocation() }
      })
      .then(({ data: { defaultValues } }: Response) => {
        recordEvent('workspace', 'space-type-changed', { spaceType: spaceId })
        this.props.loadDefaults(spaceId, defaultValues)
      })
      .catch(err => {
        console.error('Error fetching default values', err.message)
      })
  }

  render() {
    return (
      <StyledForm>
        <h4>Space type</h4>
        <label htmlFor="beam.type">
          Use of space
          <CustomSelect
            options={this.parseOptions()}
            currentVal={this.props.currentSpaceType}
            handleEventChange={this.getDefaults}
          />
        </label>
      </StyledForm>
    )
  }
}

const mapStateToProps = (state: Store.Complete) => ({
  currentSpaceType: getActiveSpaceType(state)
})

const mapDispatchToProps = (dispatch: Dispatch<Store.Complete>) => ({
  loadDefaults: (spaceType: string, defaults: DefaultValues) =>
    dispatch(loadDefaultValues(spaceType, defaults))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SpaceForm)



// WEBPACK FOOTER //
// ./src/Components/Workspace/Calculation/Editors/SpaceTypeEditor.tsx